import script from "./FormularioCategoria.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormularioCategoria.vue?vue&type=script&setup=true&lang=ts"

import "./FormularioCategoria.vue?vue&type=style&index=0&id=a5883a64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5883a64"]])

export default __exports__